// extracted by mini-css-extract-plugin
module.exports = {"message":"OfferingsListV2-module__message--4A0Z9","listContainer":"OfferingsListV2-module__listContainer--20KCo","pagination":"OfferingsListV2-module__pagination--34FUV"};